import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  authBrandPage: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  authOrgPage: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  hasOwnerBrand: false,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
